import React, { useRef, useState }              from 'react';
import { Alert, Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useDispatch }                          from 'react-redux';
import Select                                   from 'react-select';
import moment                                   from 'moment';
import Swal                                     from 'sweetalert2';
import { Formik }                               from 'formik';
import * as yup                                 from 'yup';

import ButtonSpinner                            from '../../../layout/ButtonSpinner'
import clienteAxios                             from '../../../../config/axios';
import { agendateIntAudiencesAction, cancelAudiencesAction }           from '../../../../actions/audiencesActions';
import { C_GREEN}                               from '../../../extras/colors';
import { ErrorMessage }                         from '../../../extras/toastMessages';
import { ICON_SAVE, ICON_CANCEL }               from '../../../extras/icons';
import { JUDGE_FIXED }                          from '../../../../constants/agendateTypes';
import { MSG_ERROR_SERVER }                     from '../../../../constants/messages';





const FixedForm = props => {



    // ---------------------------------------------------------------------------------------------------------------------
    // DECLARACIONES -------------------------------------------------------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------------------

    // Tomo los props
    const { show, handleClose, audience } = props;

    // Inicializo el dispatch
    const dispatch = useDispatch();

    // Genero los ref
    const refFecha = useRef();
    
    // Inicializo datos
    const initialData = {
        enviarEnlace: '1',
        fecha: '',
        fin: '',
        inicio: '',
        jueces: [],
        observacion: audience.observacionAgendamiento,
        sala: '',
        operador: '',
    }

    // Inicializo el state local
    const [judges, setJudges] = useState([]);
    const [loading, setLoading] = useState(false);
    const [operators, setOperators] = useState([]);
    const [rooms, setRooms] = useState([]);
    const [selectedJudges, setSelectedJudges] = useState([]);



    // ---------------------------------------------------------------------------------------------------------------------
    // FUNCIONES -----------------------------------------------------------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------------------

    // Manejo cuando se muestra
    const handleOnShow = e => {
        // Cargo los parámetros
        loadParameters();
        // Pongo el foco en el primer campo
        refFecha.current.focus();
    }

    // Función que maneja los parámetros
    const loadParameters = async () => {
        try
        {   // Cargo la espera
            setLoading(true);
            // Salas
            const responseRooms = await clienteAxios.get(`/sala?search=activo:1&sort=descripcion:asc`);
            // Seteo los datos
            setRooms(responseRooms.data.content);
            // Operadores
            const responseOperators = await clienteAxios.get(`/usuario?search=perfil.id:2,nivel.id:3,activo:1&sort=apellido:asc,nombre:asc`);
            // Seteo los datos
            setOperators(responseOperators.data.content);
            // Jueces
            const responseJudges = await clienteAxios.get(`/juez?search=activo:1&sort=apellido:asc,nombre:asc`);
            // Seteo los datos
            setJudges(responseJudges.data.content);
            // Oculto la espera
            setLoading(false);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            // Verifico si hay error
            if(response)
            {   data = response.data;
            }
            // Oculto la espera
            setLoading(false);
            // Mensaje de error
            ErrorMessage(data.message);
        }
    }

    // Manejo cambio del select
    const handleChangeJudges = (options, values, e, setFieldValue) => {
        // Seteo los datos
        setSelectedJudges(options ? options.map(option => (
            {   id: option.value,
                label: option.label,
                value: option.value,
            }
        )) : [])
        // Seteo el valor
        setFieldValue('jueces', options ? options : [], true);
    }

    // Manejo el guardado
    const handleSave = async values => {
        let today = new Date();
        let inicio = new Date(`${values.fecha} ${values.inicio}:00`);
        let fin = new Date(`${values.fecha} ${values.fin}:00`);
        if(today > inicio || today > fin)
        {   Swal.fire({
                title: 'Fecha Anterior',
                text: 'Ud. está por agendar una audiencia con fecha anterior a la actual. ¿Está seguro de que desea continuar?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: C_GREEN,
                confirmButtonText: 'Sí, Agendar'
            }).then((result) => {
                if(result.value)
                    schedule(values);
            })
        }
        else
            schedule(values);
    }

    // Guardar el agendamiento
    const schedule=values=>{
        // Armo los datos
        const data = {
            enviarEnlace: values.enviarEnlace,
            fin: `${values.fecha} ${values.fin}:00`,
            inicio: `${values.fecha} ${values.inicio}:00`,
            jueces: selectedJudges,
            observacion_agendamiento: values.observacion,
            operadorId: values.operador,
            salaId: values.sala,
        }
        // Llamo al dispatch
        dispatch( agendateIntAudiencesAction(audience, data, handleClose, JUDGE_FIXED) );
    }

    // Esquema de validación
    const validationSchema = yup.object({
        enviarEnlace: yup.number().required(),
        fecha: yup.date().required(),
        fin: yup.string().required(),
        inicio: yup.string().required(),
        jueces: yup.array().required(),
        sala: yup.number().required(),
        operador: yup.number().required(),
    });


    // ---------------------------------------------------------------------------------------------------------------------
    // RENDERIZO -----------------------------------------------------------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------------------
    
    return (
        <Modal
            show = { show } 
            onHide = { handleClose } 
            onShow = { handleOnShow } 
            aria-labelledby = "contained-modal-title-vcenter" 
            centered
            size = "lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <strong>Agendamiento Fijo</strong> <small>(Audiencia #{ audience.id })</small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema = { validationSchema }
                initialValues = {{ ...initialData }}
                onSubmit = { values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                    setErrors,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <Row>
                                <Col xs="12">
                                    <Alert variant="info">
                                        A continuación complete los campos para generar el Agendamiento
                                    </Alert>
                                </Col>
                                <Col xs="12">
                                    Fecha Solicitud: <strong>{ audience.fechaSolicitud ? moment(audience.fechaSolicitud).format('DD/MM/YYYY HH:mm') : '' }</strong>
                                    <hr/>
                                </Col>
                                <Form.Group className="col-12 col-md-4">
                                    <label htmlFor="fecha">Fecha</label>
                                    <Form.Control
                                        id = "fecha"
                                        className = "form-control" 
                                        autoFocus 
                                        name = "fecha" 
                                        type = "date" 
                                        placeholder = "Ingrese Fecha"
                                        value = { values.fecha }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.fecha }
                                        disabled = { loading }
                                        ref = { refFecha }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.fecha }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-12 col-md-4">
                                    <label htmlFor="inicio">Hora inicio</label>
                                    <Form.Control
                                        id = "inicio"
                                        className = "form-control" 
                                        name = "inicio" 
                                        type = "time" 
                                        placeholder = "Hora inicio"
                                        value = { values.inicio }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.inicio }
                                        disabled = { loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.inicio }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-12 col-md-4">
                                    <label htmlFor="fin">Hora fin</label>
                                    <Form.Control
                                        id = "fin"
                                        className = "form-control" 
                                        name = "fin" 
                                        type = "time" 
                                        placeholder = "Hora fin"
                                        value = { values.fin }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.fin }
                                        disabled = { loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.fin }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-12 col-md-6">
                                    <label htmlFor="sala">Sala</label>
                                    <Form.Control
                                        as = "select"
                                        id = "sala"
                                        className = "form-control"  
                                        name = "sala" 
                                        value = { values.sala }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.sala }
                                        disabled = { loading }
                                    >
                                        <option value="">Seleccione...</option>
                                        {   rooms.map(room => (
                                                <option value={room.id} key={`mfr${room.id}`}>
                                                    { room.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.sala }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-12 col-md-6">
                                    <label htmlFor="operador">Operador</label>
                                    <Form.Control
                                        as = "select"
                                        id = "operador"
                                        className = "form-control"  
                                        name = "operador" 
                                        value = { values.operador }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.operador }
                                        disabled = { loading }
                                    >
                                        <option value="">Seleccione...</option>
                                        {   operators.map(operator => (
                                                <option value={operator.id} key={`mfo${operator.id}`}>
                                                    { operator.apellido + ', ' + operator.nombre }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.operador }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-12 col-md-6">
                                    <label htmlFor="juez">Juez/ces</label>
                                    <Select
                                        name = "jueces"
                                        onChange = { (options,e)=>handleChangeJudges(options, values, e, setFieldValue) }
                                        id = "jueces"
                                        isMulti
                                        noOptionsMessage = { ()=>("No se encontraron datos") }
                                        placeholder = "Seleccione juez/ces"
                                        className = { !!errors.jueces ? `is-invalid` : '' }
                                        value = { selectedJudges }
                                        options = {
                                            judges 
                                                ?
                                                    judges.map(judge => (
                                                        {   value: judge.id,
                                                            label: `${judge.apellido}, ${judge.nombre}`
                                                        }
                                                    ))
                                                : 
                                                    []
                                        }
                                        disabled = { loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.jueces }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-12 col-md-6">
                                    <label htmlFor="enviarEnlace">¿Enviar enlace de acceso a la audiencia remota?</label>
                                    <Form.Control
                                        as = "select"
                                        id = "enviarEnlace"
                                        className = "form-control"  
                                        name = "enviarEnlace" 
                                        value = { values.enviarEnlace }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.enviarEnlace }
                                        disabled = { loading }
                                    >
                                        <option value="1">SI</option>
                                        <option value="0">NO</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        Debe seleccionar si se enviará el enlace
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-12">
                                    <label htmlFor="observacion">Observaciones del Agendamiento</label>
                                    <Form.Control
                                        id = "observacion"
                                        className = "form-control" 
                                        name = "observacion" 
                                        as = "textarea" 
                                        rows = { 4 }
                                        placeholder = "Observaciones del Agendamiento"
                                        value = { values.observacion }
                                        onChange = { handleChange }
                                        isInvalid = { !!errors.observacion }
                                        disabled = { loading }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.observacion }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            {   loading 
                                    ?
                                        <ButtonSpinner />
                                    :
                                        <Button variant="success" type="submit" disabled={ loading }>
                                            <ICON_SAVE /> <strong>AGENDAR</strong>
                                        </Button>
                            }
                            <Button variant="secondary" onClick={handleClose} disabled={ loading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default FixedForm;
